export function formatFullWeekday (date: Date, locale: Intl.Locale) {
    return date.toLocaleDateString(locale, { weekday: 'long' });
};

export function formatShortDateWithWeekday (date: Date, locale: Intl.Locale): string {
    return [date.getDate(), date.toLocaleDateString(locale, { month: 'short' }), date.getFullYear()].join(' ');
};

export function formatFullTime (date: Date, locale: Intl.Locale): string {
    return date.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit", second: "2-digit" });
};